import React from "react";
import { Bar } from "react-chartjs-2";

const data = {
  labels: [
    "Kasur",
    "Karachi",
    "Bannu",
    "Bahawlapur",
    "MirpurKhas",
    "Rawalpindi",
    "Jehlum",
    "Sukkur",
    "Turbat",
    "Larkana",
    "Hyderabad",
    "Nawabshah",
    "Peshawar",
    "Quetta",
  
  ],
  datasets: [
    {
      label: "No. of Cases",
      data: [
        50.8, 48.7,3.4, 25.1, 23.2, 21.5, 17.9, 16.7, 16.6, 16.2, 13.2, 13.2, 9.9,
        8.3,
      ],
      backgroundColor: [
        "rgba(255, 99, 132, 0.2)",
        "rgba(54, 162, 235, 0.2)",
        "rgba(150, 200, 14, 0.2)",
        "rgba(255, 206, 86, 0.2)",
        "rgba(75, 192, 192, 0.2)",
        "rgba(153, 102, 255, 0.2)",
        "rgba(255, 159, 64, 0.2)",
        "rgba(25, 19, 64, 0.2)",
        
      ],
      borderColor: [
        "rgba(255, 99, 132, 1)",
        "rgba(54, 162, 235, 1)",
        "rgba(255, 159, 64, 1)",

        "rgba(255, 206, 86, 1)",
        "rgba(75, 192, 192, 1)",
        "rgba(153, 102, 255, 1)",
      ],
      borderWidth: 1,
    },
  ],
};

const options = {
  scales: {
    yAxes: [
      {
        ticks: {
          beginAtZero: true,
        },
      },
    ],
  },
};

const VerticalBar = () => (
  <>
    <div className="header">
      <h1 className="title">
        Graphical Representation of Highly Affected Cities by HIV
      </h1>
      <div className="links"></div>
    </div>
    <Bar data={data} options={options} />
  </>
);

export default VerticalBar;
